import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getGeneralTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'facilityName',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.place',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--place',
  },
  {
    propName: 'activeCount',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.in-work',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--in-work',
  },
  {
    propName: 'idleCount',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.free-device',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--data',
  },
  {
    propName: 'totalHashrate',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.hashrate',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--data',
  },
  {
    propName: 'averageTemperature',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.average-t',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--data',
  },
  {
    propName: 'totalPower',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.power',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--data',
  },
  {
    propName: 'freePower',
    captionTranslateKey: 'monitoring.dashboard.overview-dashboard.modal.table.free-power',
    type: TableColumnTypeEnum.Text,
    colClass: 'col--data',
  },
];
